module.exports = __webpack_public_path__ + "img/game_main_pc_244_off.3d85f8c6.png";